<template>
    <div class="page_content module_page" aria-label="create career idea Page Content">

        <div class="row page-heading header connection_head">
            <div class="col-9 heading module_heading" style="padddign-top: 4px;">
                <span class="pg_icon icon-job" style="margin-left: 20px;"></span>
                <span class="ml-2"> My Career Idea </span>
                <span class="ml-3" v-if="title"> > </span>
                <span class="ml-2 subhead_txt ace_sec_hd" role="heading" aria-level="1" :aria-label="title"> {{title}} </span>
            </div>
            <div class="col-3 float-right px-0">
                <div class="submit btn-container">
                    <button class="btn btn-primary" @click="saveOrDone(true)" aria-label="done">done</button>
                    <button class="btn btn-primary" @click="saveOrDone(false)" aria-label="save">save</button>
                    <button class="btn btn-primary" @click="cancel" aria-label="cancel">cancel</button>
                </div>
            </div>
        </div>

        <div class="row page_fld_section">
        
            <div class="col-5">
                <div class="fld_label" id="title">Career Idea <sup>*</sup></div>
                <div class="fld_input">
                    <b-form-input v-model.trim="title" :state="titleState"
                        aria-labelledby="title" placeholder="career idea title"
                        @blur="$v.title.$touch()"
                        class="fld_input"
                        aria-describedby="titleFeedback" v-focus>
                    </b-form-input>
                    <b-form-invalid-feedback id="titleFeedback">
                        Career must not be empty
                    </b-form-invalid-feedback>
                </div>
            </div>

            <div class="col-1"></div>

            <div class="col-5">
                <div class="fld_label" id="interest">Interest <sup>*</sup></div>
                <div class="fld_input">
                    <b-form-select v-model="interestLevel" :options="interestLevelOptions" :state="interestLevelState" aria-describedby="interestLevelFeedback">
                    </b-form-select>
                    <b-form-invalid-feedback id="interestLevelFeedback">
                        Interest must not be empty
                    </b-form-invalid-feedback>
                </div>
            </div>
            
            <!--

            <div class="col-1"></div>

            <div class="col-2">
                <div class="mb-2">Icon <span class="action-link ico-edit mr-2"></span></div>
                <div class="thumbnail-section">
                    <div class="icon icon-job"></div>
                </div>
            </div>
            -->
            
        </div>
        
        <!--
        <div class="row page_fld_section">
            <div class="col-5">
                <div class="fld_label" id="interest">What next steps would you like to take?</sup></div>
                <div class="fld_input">
                    <textarea rows="5" cols="66" id="nextStep" maxlength="1022"
                        v-model.trim="nextStepNote">
                    </textarea>
                </div>
            </div>
        </div>
        -->

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
                </div>
            </b-modal>
        </div>

    </div>
</template>

<script>
  import Vue from 'vue'
  import { mapActions } from 'vuex'
  import Vuelidate from 'vuelidate'
  import {required} from 'vuelidate/lib/validators'
  Vue.use(Vuelidate)
  Vue.directive('focus', {
    inserted (el) {
      el.focus()
    }
  })

  export default {
    name: 'career-idea-create',
    props: ['careerIdeaId'],
    data () {
      return {
        title: null,
        socCode: null,
        interestLevel: 1,
        interestLevelOptions: [
          {value: '3', text: 'Low'},
          {value: '2', text: 'Medium'},
          {value: '1', text: 'High'}
        ],
        nextStepNote: ''
      }
    },

    validations: {
      title: {
        required
      },
      interestLevel: {
        required
      }
    },

    computed: {
      titleState () {
        return !this.$v.title.$error
      },

      interestLevelState () {
        return !this.$v.interestLevel.$error
      }
    },

    mounted () {
      if (this.careerIdeaId) {
        this.populateCareerIdeaDetail()
      }
    },

    methods: {
      ...mapActions([
        'createCareerIdea',
        'loadCareerIdeaDetail'
      ]),

      populateCareerIdeaDetail () {
        this.loadCareerIdeaDetail(this.careerIdeaId).then(res => {
          if (res) {
            this.title = res.title
            this.socCode = res.socCode
            this.interestLevel = res.interestLevel
            this.nextStepNote = res.nextStepNote
          }
        })
      },

      cancel () {
        return this.$router.push({ name: 'clearlyNextStudentDashboard' })
      },

      saveOrDone (isDone) {
        this.$v.$touch()
        if (this.titleState && this.interestLevelState) {
          this.$refs.loadingModal.show()
          let data = {
            title: this.title,
            socCode: this.socCode,
            interestLevel: this.interestLevel,
            nextStepNote: this.nextStepNote
          }
          let message = 'Career Idea "' + this.title + '" is created successfully.'
          if (this.careerIdeaId) {
            data.uuid = this.careerIdeaId
            message = 'Career Idea "' + this.title + '" is updated successfully.'
          }
          this.createCareerIdea(data).then(res => {
            this.$refs.loadingModal.hide()
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: message
            })
            if (isDone) {
              return this.$router.push({ name: 'clearlyNextStudentDashboard' })
            } else {
              this.careerIdeaId = res.uuid
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
    sup {
        color: red;
    }

    .header {
        background: #f7e5a8;
        margin-bottom: 75px;
        float: left;
        width: 100%;
        height:62px;
    }

    .heading {
        font-size: 22px;
        font-weight: 400;
        margin-top: 20px;
        padding-left: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/app/quest/components/CareerIdeaCreate.vue